import { IProduct, ITableRowExtended } from "@/services/interfaces";
import { isDiscounted } from "@/store/cart/utils";

export const getTooltips = (item: ITableRowExtended) => {
  const tooltips = [];

  const isOnDiscount = isDiscounted(item);

  try {
    if (item.onSale) {
      tooltips.push({
        value: item.stock,
        message: "Доступное количество товаров по Распродаже: " + item.stock,
      });
    } else {
      tooltips.push({
        value: item.stock,
        message: "Доступное количество товаров: " + item.stock,
      });
    }

    if (
      isOnDiscount &&
      item.quantity &&
      item.promo_stock &&
      item.quantity > item.promo_stock
    ) {
      tooltips.push({
        value: item.promo_stock,
        message: `Товар ${item.name} по цене ${item.promo_price} ₽ доступен по акции в количестве ${item.promo_stock} ед. Товар сверх этого количества будет оформлен по обычной цене: ${item.price} ₽.`,
      });
    }
  } catch (err) {
    console.warn(err);
  }

  return tooltips;
};
